import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { ContentProvider } from "@/context/ContentContext";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <ContentProvider>
          <AuthProvider>
            <Toaster theme="dark" position="top-right" richColors />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<SmoothScroll><Home /></SmoothScroll>} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </ContentProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
